import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "FrameworkAgreementIterationListPage" */
	'pages/sales/FrameworkAgreementIteration/FrameworkAgreementIterationListPage'));

export default [{ component, exact: true, path: '/framework_agreement_iterations' }];